<template>
  <div class="hs-cell-1">
    <div class="details" :style="{'border-bottom-width': showSeparator ? '1px' : '0px'}">
      <slot>
        <div class="default" :style="{width: showLogo ? 'calc(100% - 30px)' : '100%'}">
          <p v-if="type === 'html'" v-html="$getValReplaceWrap(value)"></p>
          <p v-else>{{value}}</p>
        </div>
      </slot>
      <div v-if="showLogo" class="logo" :style="{backgroundImage: `url(${require('@/assets/image/base/cell/' + logoName)})`}"></div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
/**
 * 适用于带右箭头的跳转型cell。
 * 可控制箭头的图标和是否显示箭头。
 * 可完全自定义custom-cell。
 *  ————————————————————————————
 * | 标题                    >  |
 *  ————————————————————————————
 */
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    logoName: {
      type: String,
      default: 'right_arrow_gray.png'
    },
    showLogo: {
      type: Boolean,
      default: true
    },
    showSeparator: {
      type: Boolean,
      default: true
    },
    type: { // html 以 v-html 渲染
      type: String,
      default: ''
    }
  }
}
</script>
<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/base'
@import '~common/stylus/variable'
.hs-cell-1
  width 100%
  padding 0 15px
  overflow hidden
  &.hs-cell-1-pd
    >.details
      padding 10px 0
      line-height 1.2em
      text-align justify
  >.details
    @extend .flex-row
    @extend .flex-between
    width 100%
    min-height 44px
    border-bottom 1px solid $color_gray_layer
    >.default
      @extend .flex-row
      @extend .flex-start
      height 100%
      line-height 1.2em
    >.logo
      width 16px
      height 16px
      background-size 100% 100%
  &:last-child
    >.details
      border-bottom 0px !important
</style>
